/*
 * Public API Surface of ngx-permissions
 */
export * from './lib/index';